module.exports = __webpack_public_path__ + "img/lock (1).36628f9f.svg";